module.exports = __webpack_public_path__ + "static/CityMarket_pin_hover-6e2620b35da557b40fbb6b1813e3e55f.png";